"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipLink = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_markdown_1 = __importDefault(require("react-markdown"));
var TextLink_1 = require("../TextLink/TextLink");
var Typography_1 = require("../Typography/Typography");
var TooltipLink_style_1 = __importDefault(require("./TooltipLink.style"));
/**
 * TooltipLink atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-tooltiplink--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/TooltipLink Source}
 */
var TooltipLink = function (_a) {
    var items = _a.items, label = _a.label, className = _a.className;
    var classes = (0, TooltipLink_style_1.default)();
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(TextLink_1.TextLink, __assign({ fontVariant: 'label1', className: (0, classnames_1.default)(className, classes.root), tooltip: items.map(renderItem), interactiveTooltip: true, bold: true }, { children: label })));
    function renderItem(item, index) {
        if (typeof item === 'string') {
            return ((0, jsx_runtime_1.jsx)(react_markdown_1.default, __assign({ className: classes.markdown }, { children: item }), index));
        }
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.tooltipParagraph, color: 'white' }, { children: item }), index));
    }
};
exports.TooltipLink = TooltipLink;
